<template lang="html">
  <div class="">
    <AccountSubheader />
    <p>Devices</p>
    <DevicesComponent />
  </div>
</template>

<script>
import AccountSubheader from '../../components/AccountComponents/AccountSubheader';
import DevicesComponent from '../../components/AccountComponents/DevicesComponent';
export default {
  name: "DevicesPage",
  components: {
    AccountSubheader,
    DevicesComponent
  }
}
</script>

<style lang="css" scoped>
div p{
  color: rgb(60, 3, 140);
  font-size: 36px;
  font-weight: bold;
}
</style>
